import { render, staticRenderFns } from "./cell-promo-code-usage.vue?vue&type=template&id=a716cd90&scoped=true"
import script from "./cell-promo-code-usage.ts?vue&type=script&lang=ts&external"
export * from "./cell-promo-code-usage.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-promo-code-usage.vue?vue&type=style&index=0&id=a716cd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a716cd90",
  null
  
)

export default component.exports